/** Shared with the blocking <head> bootstrap — keep this file free of "use client". */
export const THEME_STORAGE_KEY = "collab-theme";

/**
 * Blocking bootstrap for <head>. Must run before first paint — next/script
 * beforeInteractive still races hydration, which can strip `dark` from <html>.
 */
export const themeInitScript = `(function(){try{var k=${JSON.stringify(THEME_STORAGE_KEY)};var t=localStorage.getItem(k);var d=t==="dark"||(t!=="light"&&window.matchMedia("(prefers-color-scheme: dark)").matches);var el=document.documentElement;el.classList.toggle("dark",d);el.style.colorScheme=d?"dark":"light";el.style.backgroundColor=d?"#0c0e12":"#f6f7f9";}catch(e){}})();`;
